<script setup>
import {ref, computed} from 'vue'
import {useFormsStore} from '@/stores/forms'
import {useFormStore} from '@/stores/form'
import {useItemDataStore} from '@/stores/itemData'

// Component Imports
import Form from '@/common/form/Form'
import FormSaveBtn from '@/common/form/FormSaveBtn'

// Props & Emits
const props = defineProps({
    modal: Object,
    options: Object,
})

const emit = defineEmits(['hide-modal'])

// Store Access
const formsStore = useFormsStore()
const itemDataStore = useItemDataStore()

// State
const formId = ref('')
const tableName = 'odp_bookings_payment_log'
const id = 0
const bookingFormId = props.options.bookingFormId

// Dynamic Pinia Form Store Instance
const bookingFormStore = useFormStore(bookingFormId)

// Computed
const bookingId = computed(() => {
    return bookingFormStore.id
})

// Methods
const createForm = () => {
    formId.value = 'form:' + tableName + ':' + id

    // Assigning the form ID to the modal object triggers the unsaved confirmation modal
    props.modal.formId = formId.value

    formsStore.createForm({
        tableName: tableName,
        id: id,
        fieldNames: [
            'amount',
            'paymentNote',
        ],
        currentData: {
            bookingId: bookingId.value,
            label: 'Manual payment',
            date: Math.ceil(Date.now() / 1000)
        },
        onSave: (obj) => {
            const amount = obj.amount

            // Saves the booking's new amountPaid value and updates the form.
            itemDataStore.get({
                    tableName: 'odp_course_bookings',
                    id: bookingId.value
                })
                .then((res) => {
                    let amountPaid = res.amountPaid || 0
                    amountPaid = parseFloat(amountPaid) + parseFloat(amount)
                    amountPaid = amountPaid.toFixed(2)

                    // Update the active form to show the new value
                    bookingFormStore.presetData({
                        name: 'amountPaid',
                        value: amountPaid
                    })

                    // Save the booking's new amountPaid
                    return itemDataStore.update({
                        tableName: 'odp_course_bookings',
                        id: bookingId.value,
                        data: {
                            amountPaid: amountPaid
                        }
                    })
                })
                .then(() => {
                    emit('hide-modal')
                })
        },
    })
}

// Initialization (Replacement for created lifecycle hook)
createForm()
</script>

<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Add payment</h4>
                <button
                    type="button"
                    class="btn-close"
                    @click="emit('hide-modal')"
                    aria-label="Close"
                ></button>
            </div>

            <div class="modal-body">
                <Form v-if="formId" :form-id="formId"/>

                <footer class="text-center mt-3">
                    <FormSaveBtn
                        :button-text="'Save'"
                        :cancel-on-save="true"
                        :form-id="formId"
                    />
                </footer>
            </div>
        </div>
    </div>
</template>